// Providers moved to Main App or kept here if specific to module?
// For now, let's keep providers here if they are module specific, but remove BrowserRouter
// Providers moved to Main App
import { Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider } from '../../context/AuthContext'; // Moved up
// import { NotificationProvider } from '../../context/NotificationContext'; // Moved up
import ProtectedRoute from '../../components/ProtectedRoute'; // Moved up
import Layout from '../../components/layout/Layout'; // This is the OLD layout, we might need to verify if we want to keep it nested or replace it.
// Ideally, CotizaPlus has its own internal layout or uses the MainLayout.
// Let's assume we keep the internal layout for now for the "Dashboard" view.
// Let's assume we keep the internal layout for now for the "Dashboard" view.
import VerifyEmail from './pages/auth/VerifyEmail';
import RequestPasswordReset from './pages/auth/RequestPasswordReset';
import ResetPasswordConfirm from './pages/auth/ResetPasswordConfirm';
import Dashboard from './pages/dashboard/Dashboard';

import ProductList from './pages/products/ProductList';
import ProductForm from './pages/products/ProductForm';
import ClientList from './pages/clients/ClientList';
import ClientForm from './pages/clients/ClientForm';
import QuotationList from './pages/quotations/QuotationList';
import QuotationForm from './pages/quotations/QuotationForm';
import TaxManagement from './pages/taxes/TaxManagement';
import SelfServiceLink from './pages/admin/SelfServiceLink';
import Reports from './pages/admin/Reports';
import CotizaPlusSettings from './pages/admin/CotizaPlusSettings';
import PublicQuotationReview from './pages/public/PublicQuotationReview';
import PublicQuotation from './pages/public/PublicQuotation';
import MyRequests from './pages/requests/MyRequests';
import ForcePasswordChange from './pages/auth/ForcePasswordChange';

// Importar estilos
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/variables.css';
import '../../styles/components.css';

function CotizaPlusApp() {
  return (
    <Routes>
      {/* Rutas Auth manejadas en App.js global, pero mantenemos algunas específicas si es necesario */}
      {/* <Route path="/login" element={<Login />} />  <- MOVED TO GLOBAL */}
      {/* <Route path="/register" element={<Register />} /> <- MOVED TO GLOBAL */}

      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/request-password-reset" element={<RequestPasswordReset />} />
      <Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />

      {/* Ruta pública de autoatención (para clientes - solicitar) */}
      <Route path="/autoatencion/:slug" element={<PublicQuotation />} />

      {/* Ruta pública de revisión (para clientes - aceptar/rechazar) */}
      <Route path="/cotizacion/:uuid" element={<PublicQuotationReview />} />

      {/* Ruta de Cambio Contraseña Forzado */}
      <Route
        path="/change-password"
        element={
          <ProtectedRoute allowPasswordChange={true}>
            <ForcePasswordChange />
          </ProtectedRoute>
        }
      />


      {/* Rutas protegidas (Admin) */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Rutas de Productos */}
        <Route path="productos" element={<ProductList />} />
        <Route path="productos/nuevo" element={<ProductForm />} />
        <Route path="productos/editar/:id" element={<ProductForm />} />

        {/* Rutas de Clientes */}
        <Route path="clientes" element={<ClientList />} />
        <Route path="clientes/nuevo" element={<ClientForm />} />
        <Route path="clientes/editar/:id" element={<ClientForm />} />

        {/* Rutas de Cotizaciones */}
        <Route path="cotizaciones" element={<QuotationList />} />
        <Route path="cotizaciones/nuevo" element={<QuotationForm />} />
        <Route path="cotizaciones/editar/:id" element={<QuotationForm />} />

        {/* Ruta de Impuestos */}
        <Route path="impuestos" element={<TaxManagement />} />


        <Route path="autoatencion" element={<SelfServiceLink />} />
        <Route path="reportes" element={<Reports />} />
        <Route path="mis-solicitudes" element={<MyRequests />} />
        {/* <Route path="mis-solicitudes" element={<MyRequests />} /> DUPLICATE REMOVED */}
        <Route path="configuracion" element={<CotizaPlusSettings />} />
      </Route>

      {/* Ruta por defecto dentro del módulo */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default CotizaPlusApp;


